"use client";

import { types } from "react-bricks/frontend";
import styled from "styled-components";
import { color } from "@utils";
import {
  VerticalPadding,
  VerticalPaddingWrapper,
  verticalPadSideProp,
} from "../utils/verticalPadding";
import { restrictedBackgroundColorProp } from "../utils/backgroundColor";
import { useLocale } from "@hooks";
import { convertNextLocaleToLanguage } from "@utils";
import { useEffect, useRef } from "react";

export interface TrustpilotSectionSmallProps {
  paddingVertical?: VerticalPadding;
  backgroundColor?: types.IColor;
  alignment: "left" | "center";
}

const TrustpilotSectionSmall: types.Brick<TrustpilotSectionSmallProps> = ({
  paddingVertical = "none",
  backgroundColor = { color: color.white },
  alignment = "left",
}) => {
  const { locale } = useLocale();
  const widgetRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!widgetRef.current || typeof window === "undefined") {
      return;
    }

    const loadWidget = () => {
      if (window.Trustpilot && widgetRef.current) {
        window.Trustpilot.loadFromElement(widgetRef.current, true);
      }
    };

    if (!window.Trustpilot) {
      const script = document.createElement("script");
      script.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      script.async = true;
      script.onload = loadWidget;
      document.body.appendChild(script);
    } else {
      loadWidget();
    }
  }, []);
  return (
    <VerticalPaddingWrapper
      paddingVertical={paddingVertical}
      backgroundColor={backgroundColor?.color}
    >
      <FlexContainer alignment={alignment}>
        <Container>
          <div
            ref={widgetRef}
            className="trustpilot-widget"
            data-locale={convertNextLocaleToLanguage(locale)}
            data-template-id="5419b6ffb0d04a076446a9af"
            data-businessunit-id="5baa48c16b01ec0001b76165"
            data-style-width="100%"
            data-font-family="Montserrat"
            data-text-color="#5c5757"
          >
            <a
              href="https://uk.trustpilot.com/review/www.yulife.com"
              target="_blank"
              rel="noopener"
            >
              Trustpilot
            </a>
          </div>
        </Container>
      </FlexContainer>
    </VerticalPaddingWrapper>
  );
};

TrustpilotSectionSmall.schema = {
  name: "trustpilot-section-small",
  label: "Trustpilot Section Small",
  previewImageUrl: "  /static/bricks/trustpilot-section-small.png",
  getDefaultProps: () => ({
    paddingVertical: "none",
    backgroundColor: { color: color.white },
    alignment: "center",
  }),
  sideEditProps: [
    verticalPadSideProp,
    restrictedBackgroundColorProp,
    {
      name: "alignment",
      label: "Alignment",
      type: types.SideEditPropType.Select,
      selectOptions: {
        display: types.OptionsDisplay.Radio,
        options: [
          { value: "left", label: "Left" },
          { value: "center", label: "Center" },
        ],
      },
    },
  ],
};

const FlexContainer = styled.div<{ alignment: "left" | "center" }>`
  width: 100%;
  display: flex;
  justify-content: ${(p) => (p.alignment === "left" ? "flex-start" : "center")};
  height: 3.125rem;
`;

const Container = styled.div`
  margin-top: 1rem;
  width: 26.25rem;

  @media screen and (max-width: 450px) {
    max-width: 10.625rem;
    margin-top: 0;
    margin-left: 2rem;
  }
`;

export default TrustpilotSectionSmall;
